import {
  FINANCIAL_TRACKING_ADD_NEW,
  FINANCIAL_TRACKING_DELETE,
  FINANCIAL_TRACKING_EDIT,
  FINANCIAL_TRACKING_GET_BY_ID,
  FINANCIAL_TRACKING_GET_BY_ID_SUCCESS,
  FINANCIAL_TRACKING_GET_LIST,
  FINANCIAL_TRACKING_GET_LIST_SUCCESS,
  FINANCIAL_TRACKING_ADD_NEW_REQUEST,
  FINANCIAL_TRACKING_RESULT_CHANGE,
  FINANCIAL_TRACKING_ERROR,
} from './types';

// item
const initialState = {
  items: [],
  item: null,
  notifications: [],
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
  itemCount: 0,
  pageCount: 0,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FINANCIAL_TRACKING_RESULT_CHANGE:
    case FINANCIAL_TRACKING_GET_BY_ID:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case FINANCIAL_TRACKING_GET_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        item: payload,
      };

    case FINANCIAL_TRACKING_ADD_NEW_REQUEST:
      return {
        ...state,
        addSuccess: false,
      };
    case FINANCIAL_TRACKING_GET_LIST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case FINANCIAL_TRACKING_GET_LIST_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        items: data,
        loading: false,
        itemCount,
        pageCount,
        addSuccess: true,
        editSuccess: true,
        deleteSuccess: true,
      };
    case FINANCIAL_TRACKING_ADD_NEW:
      return {
        ...state,
        loading: true,
        error: null,
        addSuccess: false,
      };

    case FINANCIAL_TRACKING_EDIT:
      return {
        ...state,
        loading: true,
        error: null,
        editSuccess: false,
      };
    case FINANCIAL_TRACKING_DELETE:
      return {
        ...state,
        loading: true,
        error: null,
        deleteSuccess: false,
      };

    case FINANCIAL_TRACKING_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return { ...state };
  }
};
